if (!customElements.get('mobile-menu-drawer')) {
  customElements.define('mobile-menu-drawer', class MobileMenuDrawer extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-menu-tab]');
      this.views = this.querySelectorAll('[data-menu-view]');
      this.main = this.querySelector('[data-menu-main]');
      this.concerns = this.querySelector('[data-menu-concerns]');
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.selectBrand(tab.dataset.menuTab)));
      this.querySelector('[data-menu-open-concerns]')?.addEventListener('click', () => this.openConcerns());
      this.querySelector('[data-menu-back]')?.addEventListener('click', () => this.closeConcerns());
    }
    selectBrand(brand) {
      this.tabs.forEach((tab) => { const active = tab.dataset.menuTab === brand; tab.classList.toggle('is-active', active); tab.setAttribute('aria-selected', String(active)); });
      this.views.forEach((view) => { view.hidden = view.dataset.menuView !== brand; });
    }
    openConcerns() { this.main.hidden = true; this.concerns.hidden = false; this.scrollTop = 0; }
    closeConcerns() { this.concerns.hidden = true; this.main.hidden = false; this.scrollTop = 0; }
  });
}
